import {
  setGuideInstructionalCoaching,
  setGuideInstructionalCoachings,
} from "reduxStore/state";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getGuideInstructionalCoachings =
  () => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(`${BASE_URL}/guideInstructionalCoaching`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to get guides");
      }

      const guides = await response.json();

      dispatch(setGuideInstructionalCoachings(guides));
      return guides;
    } catch (error) {
      console.error("Error while getting guides:", error);
      return null;
    }
  };

export const getGuideInstructionalCoachingById =
  (id) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(
        `${BASE_URL}/guideInstructionalCoaching/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to get guide");
      }

      const guide = await response.json();

      dispatch(setGuideInstructionalCoaching(guide));
      return guide;
    } catch (error) {
      console.error("Error while getting guide:", error);
      return null;
    }
  };

export const createGuideInstructionalCoaching =
  (guide) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(`${BASE_URL}/guideInstructionalCoaching`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(guide),
      });

      if (!response.ok) {
        throw new Error("Failed to create guide");
      }

      const createdGuide = await response.json();

      dispatch(setGuideInstructionalCoaching(createdGuide));
      dispatch(getGuideInstructionalCoachings());

      return createdGuide;
    } catch (error) {
      console.error("Error while creating guide:", error);
      return null;
    }
  };

export const updateGuideInstructionalCoaching =
  (guide) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(
        `${BASE_URL}/guideInstructionalCoaching/${guide._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(guide),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update guide");
      }

      const updatedGuide = await response.json();

      dispatch(setGuideInstructionalCoaching(updatedGuide));
      return updatedGuide;
    } catch (error) {
      console.error("Error while updating guide:", error);
      return null;
    }
  };

export const deleteGuideInstructionalCoaching =
  (id) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(
        `${BASE_URL}/guideInstructionalCoaching/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete guide");
      }

      dispatch(getGuideInstructionalCoachings());
      return true;
    } catch (error) {
      console.error("Error while deleting guide:", error);
      return false;
    }
  };
